import React, { useState, useEffect, Fragment } from "react";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import SignInForm from "corp-site/components/SignInForm";

import { logInUser, employerResetPassword } from "../../services/EmployerServices";
import ForgotPasswordForm from "corp-site/components/ForgotPasswordForm";
import AccountVerificationForm from "../accountVerification/AccountVerificationForm";


const EmployerSignIn = ({ className, history, location }) => {
    const [showSigninForm, setshowSigninForm] = useState(true);
    const [loginError, setLoginError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showAccountVerify, setShowAccountVerify] = useState(false);
    const [showAccountVerifySuccess, setShowAccountVerifySuccess] = useState(false);
    const [vt, setVt] = useState("");
    const [errorParam, setErrorParam] = useState("");
    const [passwordError, setPasswordError] = useState({ "success": false, "message": "" });
    const qs = queryString.parse(location.search);

    useEffect(() => {
        if (qs && qs.error) {
            setErrorParam(qs.error);
        }
        if (qs && qs.vt) {
            setVt(qs.vt);
        }
    }, [qs]);

    // useEffect(() => { // try to login user when this component loads
    //     if (localStorage.getItem("token")) {
    //         setIsLoading(true);
    //         const subscription = fetchUserDetails().subscribe({
    //             next: (data) => {
    //                 if (data.response === 'success') {
    //                     window.location = '/employer/'
    //                 } else {
    //                     setIsLoading(false);
    //                 }
    //             },
    //             complete: (data) => {
    //                 subscription.unsubscribe();
    //                 setIsLoading(false);
    //             }
    //         })
    //     }
    // }, []);

    const onCloseModal = () => {
        history.push(location.pathName);
    }

    const onVerficationSuccess = () => {
        setShowAccountVerify(false);
        setShowAccountVerifySuccess(true);
    }

    const signInAccountVerifyShow = (event) => {
        setShowAccountVerify((prev) => {
            return !prev
        });
        event.preventDefault();
    }

    const handleFormSubmit = (data) => {
        if (data && data.rememberMe) {
            localStorage.setItem("rememberMe", true);
        } else {
            localStorage.setItem("rememberMe", false);
        }
        setIsLoading(true);
        logInUser(data).subscribe(
            (loginResponse) => {
                if (loginResponse.response === "success") {
                    localStorage.setItem("token", loginResponse.message);
                    setTimeout(() => {
                        // window.location = "/empl/auth/login";
                        window.location = "/t/employer/";
                    }, 10);
                } else if (loginResponse.response === "failure" && loginResponse.message === "verification_failure") {
                    window.location = "/employers?error=vr&vt=" + (loginResponse.vt ? loginResponse.vt : "");
                } else {
                    setLoginError(loginResponse.message);
                    setIsLoading(false);
                }
            }
        )
    }

    const handleForgotPassword = (formData) => {
        let newData = formData;
        newData['email'] = formData['username'];
        setIsLoading(true);
        employerResetPassword(formData).subscribe(
            (resetResponse) => {
                if (resetResponse.response === "success") {
                    setPasswordError({ "success": true, "message": resetResponse.message })
                } else {
                    setPasswordError({ "success": false, "message": resetResponse.message })
                }
                setIsLoading(false);
            }
        )
    }

    return (
        <Modal isOpen={true} className={(className ? className : "") + " rounded_modal signin-modal"} toggle={onCloseModal} keyboard={true} >
            <button type="button" onClick={onCloseModal} className="close modalClose" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            {!showAccountVerify && <ModalHeader>{showSigninForm ? 'Employer Sign In' : 'Forgot your password?'}</ModalHeader>}
            {showAccountVerify && <ModalHeader>Account Verification</ModalHeader>}
            {showAccountVerifySuccess && <ModalHeader>Success</ModalHeader>}
            <ModalBody>
                {!showAccountVerify && !showAccountVerifySuccess &&
                    <Fragment>
                        {errorParam === "vr" && <div className="bg-light-orange px-3 py-1 rounded mb-3" style={{ "fontSize": "1rem" }}>
                            Please <button onClick={signInAccountVerifyShow} style={{ "fontSize": "1rem" }} className="btn btn-link text-dark-blue px-1">verify your account</button> to begin posting jobs.
                        </div>}
                        {showSigninForm &&
                            <React.Fragment>
                                <SignInForm onSubmit={handleFormSubmit} loginError={loginError} isLoading={isLoading} initialValues={{ rememberMe: true }} /><div className="text-center mt-2"><button className="btn btn-reset" onClick={() => setshowSigninForm(false)}>Reset Password</button></div>
                            </React.Fragment>
                        }
                        {!showSigninForm &&
                            <React.Fragment>
                                <ForgotPasswordForm onSubmit={handleForgotPassword} passwordError={passwordError} isLoading={isLoading} ></ForgotPasswordForm>
                                <div className="text-center mt-2"><button className="btn btn-reset" onClick={() => setshowSigninForm(true)}>Back to Sign In</button></div>
                            </React.Fragment>
                        }
                    </Fragment>
                }
                {showAccountVerify && <Fragment>
                    <p>Your account requires verification because our Quality Assurance team has determined that it does not meet with our standards. You may verify your account by completing the below form.</p>
                    <AccountVerificationForm vt={vt} onSuccessfullSubmission={onVerficationSuccess}></AccountVerificationForm>
                </Fragment>}
                {showAccountVerifySuccess && <p>Your information has been submitted to our Quality Assurance team. You will be contacted once your account is verified.</p>}
            </ModalBody>
            <ModalFooter>
                <div className="float-right">
                    Don't have an account? <a href="https://www.jobcase.com/employer-onboarding?utm_source=Upward">Sign up</a>
                </div>
            </ModalFooter>
        </Modal>
    )

}


export default withRouter(EmployerSignIn);
